import { configure } from 'react-modal-portal'

configure({
  getRoot: () => document.querySelector('#root')!,
})